mutation RemoveMerchShop($shop: String!, $accountId: ID!) {
  result: StreamToolsRemoveMerchShop(shop: $shop, accountId: $accountId) {
    id
    deleted
  }
}
